/**
 * Transition will work upon calculating and setting
 * section body height at different states.
 *
 * NOTE: these functions are extracted here to allow
 * easier testing and ensure sufficient coverage that
 * would not be done if located within the component
 * file itself.
 */
// HANDLERS FOR EXPANDING

/**
 * Before expanding `height` should be set to `scrollHeight`.
 * @param {node} sectionBody.
 */
export function handleExpanding(sectionBody) {
  sectionBody.style.height = `${sectionBody.scrollHeight}px`;
}
/**
 * Once expanded remove `height` property from section body.
 */

export function handleExpanded(sectionBody) {
  sectionBody.style.height = null;
} // HANDLERS FOR COLLAPSING

/**
 * Before collapsing set `height` property to `offSetHeight` and return the `offsetHeight`.
 * @param {node} sectionBody.
 * @return {number} Returns sectionBody.offsetHeight.
 */

export function handleCollapse(sectionBody) {
  sectionBody.style.height = `${sectionBody.scrollHeight}px`;
  return sectionBody.offsetHeight;
}
/**
 * Once collapsed set `height` to '0'.
 * @param {node} sectionBody.
 */

export function handleCollapsing(sectionBody) {
  sectionBody.style.height = "0";
}